/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.ProductDevelopment {

    import fld = PDQuotationItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.registerEditor()
    export class PDQuotationItemsEditor extends _Ext.ItemGridEditor<PDQuotationItemsRow> {
        protected getColumnsKey() { return "ProductDevelopment.QuotationItems"; }
        protected getDialogType() { return PDQuotationItemsDialog; }
        protected getLocalTextPrefix() { return PDQuotationItemsRow.localTextPrefix; }

        protected form: PDQuotationItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }
        // #region Variables
        
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as PDQuotationDialog).CalculateAmountandTax();
                }
            })
        } 

        protected createToolbarExtensions(): void {
            super.createToolbarExtensions();
        }


        // #region Column Add -Remove
        protected getColumns() {

            let columns = super.getColumns();

            let num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            let int = ctx => ColumnFormatter.integerInputFormatter(ctx, this); 
            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = num;
             
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        //**** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            let item = this.itemAt(row);
            let target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        let id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);
                        this.element.trigger('dialogclose');

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // let x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    let input = $(e.target);
                    if (input != undefined) {
                        if (this.canUpdate == 0) {
                            //Check Editable
                            target.addClass('readonly');
                            target.blur();
                            Q.alert("Readonly Detected")

                        }
                        else if (this.canUpdate == 1) {
                            target.removeClass('readonly');
                            let input = $(e.target);
                            let y = input.data();
                            if (y.field == "Weight" && item.ItemTypeId == 101) {
                                target.addClass('readonly');
                                target.blur();
                            }
                            else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                                target.addClass('readonly');
                                target.blur();
                            }
                        }
                    }

                    this.view.refresh();
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            let cell = this.slickGrid.getCellFromEvent(e);
            let item = this.itemAt(cell.row);
            let input = $(e.target);
            let field = input.data('field');
            let text = Q.coalesce(Q.trimToNull(input.val()), '0');
            let id = this.id(item);
            let pending = this.pendingChanges[id];

            // *** Format Number ***
            let effective = this.getEffectiveValue(item, field);
            let oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            let value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                let i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }

            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                    item[field] = value;
                }

            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {
                if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                    item[field] = value;
                }
            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            item.CCGrossAmount = item.GrossAmount * this.ExchangeRate;
            item.CCNetAmount = item.NetAmount * this.ExchangeRate;

            this.view.updateItem(id, item);
            this.view.refresh();
            this.element.trigger('dialogclose');
            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            let id = this.id(item);
            let pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion

        setMasterValues() {
            this.RateListId = (this.parentDialog as PDQuotationDialog).RateListId;
            this.LaborListId = (this.parentDialog as PDQuotationDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as PDQuotationDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as PDQuotationDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as PDQuotationDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as PDQuotationDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as PDQuotationDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as PDQuotationDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as PDQuotationDialog).form.PartyId.value);
            this.MarkUpPolicyId = (this.parentDialog as PDQuotationDialog).MarkUpPolicyId;
            this.coef = (this.parentDialog as PDQuotationDialog).Coef;
            //this.form.VoucherTypeId.value = (this.parentDialog as PDQuotationDialog).form.VoucherTypeId.value;
        }

        // #region Buttons Add-Remove
        protected getButtons() {
            let self = this;
            let buttons = super.getButtons();
            buttons.filter(x => x.cssClass == "add-button")[0].visible = false;
            let addbutton = buttons.filter(x => x.cssClass == "add-button")[0];

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Designs",
                cssClass: "add-button",
                hotkey: "alt+k",
                onClick: () => {
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    } else {

                        //OMS.ProductSelectGrid.ItemType = 1;
                        let grid = Common.DesignSelectGrid;
                        let filters: _Ext.SelectGridFilters = {
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        let ItemDetails = ItemGridHelper.SetSalesOrderGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup, this.MarkUpPolicyId,false,true);

                        for (let Itemdetail of ItemDetails) {
                            Itemdetail.ProductId = null;
                            Itemdetail.Line_No = null;
                            let Rate = 0;
                            Itemdetail.BOMDetails.forEach(function (bom: PDQuotationBOMRow) {
                                bom.BomRate = bom.BomRate * self.coef;
                                bom.BomAmount = bom.BomAmount * self.coef;
                                Rate += bom.BomAmount;
                            });
                            let laborRate = 0;
                            Itemdetail.LaborDetails.forEach(function (labor: PDQuotationLaborRow) {
                                labor.LabourAmount = labor.LabourAmount * self.coef;
                                switch (labor.CalcOnId) {
                                    case 61:
                                        labor.LabourRate = labor.LabourAmount / labor.Pieces;
                                        break;
                                    case 62:
                                    case 63:
                                    case 64:
                                    case 65:
                                        labor.LabourRate = labor.LabourAmount / labor.Weight;
                                        break;

                                }
                                laborRate += labor.LabourAmount;
                            });
                            Itemdetail.UnitRate = Rate;
                            Itemdetail.UnitLabour = laborRate;
                            Itemdetail.NetAmount = Rate + laborRate;
                            //Itemdetail.GrossAmount = Itemdetail.NetAmount * Itemdetail.Pieces;                           
                            Itemdetail.AdditionalCharges = this.SetAdditionalCharges(Itemdetail);
                            let AddCharges = 0;
                            Itemdetail.AdditionalCharges.forEach(function (charge: PDQuotationAdditionalChargesRow) {
                                charge.Rate = charge.Rate * self.coef;
                                charge.Amount = charge.Amount * self.coef;
                                AddCharges += charge.Amount;
                            });
                            Itemdetail.AdditionalAmount = AddCharges;
                            Itemdetail.GrossAmount = (Itemdetail.NetAmount + Itemdetail.AdditionalAmount) * Itemdetail.Pieces;

                            Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Itemdetail);
                        }

                        //this.setData(ItemDetails);
                    }
                    pickerDialog.dialogOpen();
                }
            });


            buttons.push({
                title: "Spec Sheet",
                cssClass: "add-button",
                hotkey: "alt+k",
                onClick: () => {
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    } else {

                        //OMS.ProductSelectGrid.ItemType = 1;
                        let grid = ProductDevelopment.SpecSheetSelectGrid;
                        let filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        let ItemDetails = [];

                        selectedItems2.forEach(function (Item: SpecSheetItemsRow) {
                            // #region variables
                            let CompanyId = Q.Authorization.userDefinition.CompanyId;
                            let Rate = 0;
                            let LaborRate = 0;
                            let Pieces = 0;
                            let Weight = 0;
                            let BOMRate = 0;
                            let Amount = 0;
                            let Cost = 0;
                            let Studded: number;
                            let Purity = 0;
                            let PurityDetails: OMS.AttributeMasterRow;
                            let bomdetails = []; 

                            // #endregion
                            if (Item.Pieces == null)
                                Item.Pieces = 1;
                            let SalesItem: ProductDevelopment.PDQuotationItemsRow = {
                                DesignId: Item.DesignId,
                                AttributeId: Item.AttributeId,
                                Attribute: Item.Attribute,
                                PartyId: self.PartyId,
                                DesignCode: Item.DesignCode, 
                                ItemTypeId: Item.ItemTypeId,
                                HasBom: Item.HasBom,
                                CategoryId: Item.CategoryId,
                                ProductTypeId: Item.ProductTypeId,
                                SubCategoryId: Item.SubCategoryId,
                                BrandId: Item.BrandId,
                                SuperTypeId: Item.SuperTypeId,
                                CollectionId: Item.CollectionId,
                                ProductSizeId: Item.ProductSizeId,
                                UnitRate: Rate,
                                UnitLabour: LaborRate,
                                UnitCost: Cost,
                                Pieces: Item.Pieces >= 0 ? Item.Pieces : 1,
                                Weight: Item.Weight,
                                OtherPieces: Item.OtherPieces,
                                
                                OtherWeight: Item.OtherWeight,
                                StonePieces: Item.StonePieces,
                                StoneWeight: Item.StoneWeight,
                                NetWeight: Item.NetWeight,
                                NetAmount: Amount,
                                GrossAmount: Amount,
                                DiamondPieces: Item.DiamondPieces,
                                DiamondWeight: Item.DiamondWeight,
                                BOMDetails: Item.BOMDetails, 
                                CompanyId: CompanyId,
                                MetalId: Item.MetalId,
                                KaratId: Item.KaratId,
                                MetalColorId: Item.MetalColorId,
                                QualityId: Item.QualityId,
                                SieveId: Item.SieveId,
                                ShapeId: Item.ShapeId,
                                StoneColorId: Item.StoneColorId,
                                StoneSizeId: Item.StoneSizeId,
                                ImageName: Item.ImageName,
                                Image1: Item.Image1,
                                Image2: Item.Image2,
                                Image3: Item.Image3,
                                Video1: Item.Video1,
                                Video2: Item.Video2,
                                Studded: Studded, // marking item as bulk
                                StoneCutId: Item.StoneCutId,
                                StonePolishId: Item.StonePolishId,
                                StoneSymmetryId: Item.StoneSymmetryId,
                                StoneFluorescenceId: Item.StoneFluorescenceId,
                                StoneCuletId: Item.StoneCuletId,
                                StoneGirdleId: Item.StoneGirdleId,
                                StoneTable: Item.StoneTable,
                                StoneDepth: Item.StoneDepth,
                                Purity: Purity,
                                PureWeight: Weight * Purity,
                                Parts: Item.Parts,
                                RefNo: Item.RefNo,
                                Iteration: Item.Iteration,
                                StatusId: 26,
                                StampId: Item.StampId,
                            };

                            ItemDetails.push(SalesItem);
                        });
                        let _ItemDetails = ItemGridHelper.SetSalesOrderGrid(ItemDetails, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup, this.MarkUpPolicyId, false, true);


                        for (let Itemdetail of _ItemDetails) {
                            Itemdetail.ProductId = null;
                            Itemdetail.Line_No = null;
                            let Rate = 0;
                            Itemdetail.BOMDetails.forEach(function (bom: PDQuotationBOMRow) {
                                bom.BomRate = bom.BomRate * self.coef;
                                bom.BomAmount = bom.BomAmount * self.coef;
                                Rate += bom.BomAmount;
                            });
                            let laborRate = 0;
                            Itemdetail.LaborDetails.forEach(function (labor: PDQuotationLaborRow) {
                                labor.LabourAmount = labor.LabourAmount * self.coef;
                                switch (labor.CalcOnId) {
                                    case 61:
                                        labor.LabourRate = labor.LabourAmount / labor.Pieces;
                                        break;
                                    case 62:
                                    case 63:
                                    case 64:
                                    case 65:
                                        labor.LabourRate = labor.LabourAmount / labor.Weight;
                                        break;
                                    
                                }
                                laborRate += labor.LabourAmount;
                            });
                            Itemdetail.UnitRate = Rate;
                            Itemdetail.UnitLabour = laborRate;
                            Itemdetail.NetAmount = Rate + laborRate;
                            //Itemdetail.GrossAmount = Itemdetail.NetAmount * Itemdetail.Pieces;                           
                            Itemdetail.AdditionalCharges = this.SetAdditionalCharges(Itemdetail);
                            let AddCharges = 0;
                            Itemdetail.AdditionalCharges.forEach(function (charge: PDQuotationAdditionalChargesRow) {
                                charge.Rate = charge.Rate * self.coef;
                                charge.Amount = charge.Amount * self.coef;
                                AddCharges += charge.Amount;
                            });
                            Itemdetail.AdditionalAmount = AddCharges;
                            Itemdetail.GrossAmount = (Itemdetail.NetAmount + Itemdetail.AdditionalAmount)  * Itemdetail.Pieces; 

                            Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Itemdetail);
                        }
                    }
                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        setData(ItemDetails: any[]) {
            for (let Itemdetail of ItemDetails) {
                Itemdetail.Line_No = null;
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }

        SetAdditionalCharges(Item: any) {
            let AdditionalCharges: OMS.AdditionalChargesRow[];

            OMS.AdditionalChargesVouchersService.List({
                VoucherTypeId: 104, ApplicableOn: 1
            },
                response => AdditionalCharges = response.Entities,
                { async: false }
            );

            let charges= [];

            for (let add of AdditionalCharges) {

                let Amount = 0;

                if (add.ProductCalculateOn == 2) {
                    Amount = add.RateType == 2 ? Item.NetAmount * (add.Rate / 100) : add.Rate;
                }

                if (add.ProductCalculateOn == 1) {
                    Amount = add.RateType == 2 ? Item.NetAmount * (add.Rate / 100) : add.Rate;
                }

                let charge: ProductDevelopment.PDQuotationAdditionalChargesRow = {

                    AdditionalChargeId: add.AdditionalChargeId,
                    AdditionalChargeCode: add.AdditionalChargeCode,
                    ApplicableOn: add.ApplicableOn,
                    ProductCalculateOn: add.ProductCalculateOn,
                    Chargeable: Item.NetAmount,
                    RateType: add.RateType,
                    Rate: add.Rate,
                    Amount: Amount,
                }

                charges.push(charge);
            }

            return charges;

            //this.form.AdditionalCharges.setData(AdditionalCharges);


        }

        // #endregion

    }
}